import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { MessageService } from '../services/message.service';
import { Route } from '../interfaces/route';
import { Trip } from '../interfaces/trip';

const calendarUrl = "https://s3.amazonaws.com/flat-api.septa.org/prod/schedules/calendar";
const calendarExtension = "calendar.json";
const calendarDatesExtension = "calendar_dates.json";

const serviceidsUrl = "https://s3.amazonaws.com/flat-api.septa.org/prod/schedules/calendar";
const serviceidsExtension = "service_ids.json";


const timetablesUrl = "https://s3.amazonaws.com/flat-api.septa.org/prod/schedules/timetables";
const timetablesExtension = "timetable.json";


@Injectable({
  providedIn: 'root'
})
export class SchedulesService {
  public selectedTrip: any;
  public selectedRoute: any;
  private trainsScheduleUrl = 'https://www3.septa.org/api/TrainView/schedule.php?train=';
  private data: any = [];

  public calendar: any[];
  public calendar_dates: any[];
  public route_service_ids: any[] = [];

  public timetables: any[];

  public special_schedule: boolean = false;
  public service_ids: any[];

  public calendar_service_id: any[] = [];
  public calendar_date_service_id: any[] = [];

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient, private messageService: MessageService) {

      //var data = this.get_current_service_id();

      //console.log(data);
  }

  /** GET schedule from api */
  get (block: string): Observable<any[]> {
    this.data = this.http.jsonp<Route[]>(this.trainsScheduleUrl + block, 'callback')
    .pipe(
      map ((array: any) => array = this.transform(array)),
      tap (_ => this.log('fetched routes')),
      catchError (this.handleError<Route[]>('get', []))
    );

    return this.data;
  }

  public get_current_service_id(route: string, direction: string = "0"){

    const bus_calendar = this.http.get(calendarUrl + "/" + "bus" + "/" + calendarExtension);
    const bus_calendar_dates = this.http.get(calendarUrl + "/" + "bus" + "/" + calendarDatesExtension);
    const rail_calendar = this.http.get(calendarUrl + "/" + "rail" + "/" + calendarExtension);
    const rail_calendar_dates = this.http.get(calendarUrl + "/" + "rail" + "/" + calendarDatesExtension);
    const bus_service = this.http.get(serviceidsUrl + "/" + "bus" + "/" + serviceidsExtension);
    const rail_service  = this.http.get(serviceidsUrl + "/" + "rail" + "/" + serviceidsExtension);

    var data = forkJoin([bus_calendar, bus_calendar_dates, rail_calendar, rail_calendar_dates, bus_service, rail_service]).subscribe( result => {
      var bus_calendar_service_ids = this.format_calendar(result[0]);
      var bus_calendar_dates_service_ids = this.format_calendar_dates(result[1]);
      var rail_calendar_service_ids = this.format_calendar(result[2]);
      var rail_calendar_dates_service_ids = this.format_calendar_dates(result[3]);
      var bus_valid_service_ids = this.format_valid_service_ids(result[4]);
      var rail_valid_service_ids = this.format_valid_service_ids(result[5]);

      if(bus_calendar_dates_service_ids.length > 0){
        bus_calendar_service_ids = bus_calendar_dates_service_ids;
      }

      if(rail_calendar_dates_service_ids.length > 0){
        rail_calendar_service_ids = rail_calendar_dates_service_ids;
      }

      var service_ids = [ ...bus_calendar_service_ids, ...rail_calendar_service_ids ]
      var valid_service_ids = [ ...bus_valid_service_ids, ...rail_valid_service_ids ]

      this.service_ids = service_ids;

      for(const service_id of service_ids){

        for(const valid_service_id of valid_service_ids){
          if(valid_service_id.service_id == service_id && valid_service_id.route_id == route){
            this.get_timetable(route, "0", service_id).subscribe();
          }
        }
        
      }



      return service_ids
    });

    return data;
  }

  private transform(reponse: any): any {
    var transformed: any[] = [];
    for (const stop of reponse) {
      transformed.push({
        id: stop.station,
        stop: stop.station,
        track: stop.track_change == '' ? stop.track : stop.track_change, //stop.track_change
        isTrackChange: stop.track_change == '' ? false : true,
        scheduled: stop.sched_tm,
        estimated: stop.est_tm,
        actual: stop.act_tm
      });
    }

    return transformed;
  }

  public fileExists(url: string): Observable<boolean> {
    return this.http.get(url).pipe(map(() => true), catchError(() => of(false)));
  }

  // Get timetable for route and direction
  public get_timetables(route_id: string, direction_id: string, calendar: any[]): Observable<any[]> {

    return data;

    this.timetables = []

    for (const service_id of this.service_ids) {
      var url = timetablesUrl + "/" + service_id + "/" + route_id + "/" + direction_id + "/" + timetablesExtension;

      for (const valid_service of this.route_service_ids){
        if(valid_service.route_id == route_id && valid_service.service_id == service_id){
          var data = this.http.get(url).pipe(
            map((array: any) => array = this.format_timetables(array)),
            tap(_ => this.log('fetched time tables')),
            catchError(this.handleError<any[]>('get', []))
          );

          return data;
        }
      }
    }

    return data
  }

    // Get the calendar for given mode (rail/bus)
    public get_timetable(route_id: string, direction_id: string, service_id: string): Observable<any[]> {

      var url = timetablesUrl + "/" + service_id + "/" + route_id + "/" + direction_id + "/" + timetablesExtension;

      var data = this.http.get(url)
        .pipe(
          map((array: any) => array = this.format_timetables(array)),
          tap(_ => this.log('fetched stop times')),
          catchError(this.handleError<any[]>('get', []))
        );

        return data;
    
    }

  // Get the calendar for given mode (rail/bus)
  public get_calendar(mode: string): Observable<any[]> {

    var url = calendarUrl + "/" + mode + "/" + calendarDatesExtension;

    var data = this.http.get(url)
      .pipe(
        map((array: any) => array = this.format_calendar_dates(array)),
        tap(_ => this.log('fetched stop times')),
        catchError(this.handleError<any[]>('get', []))
      );

    return data;
  }

  // Get the calendar_dates for given mode (rail/bus)
  public get_calendar_dates(mode: string): Observable<any[]> {

    var url = calendarUrl + "/" + mode + "/" + calendarDatesExtension;

    var data = this.http.get(url)
      .pipe(
        map((array: any) => array = this.format_calendar_dates(array)),
        tap(_ => this.log('fetched stop times')),
        catchError(this.handleError<any[]>('get', []))
      );

    return data;
  }

  // Get the service_ids for all routes for given mode (rail/bus)
  public get_route_service_ids(mode: string): Observable<any[]> {

    var url = serviceidsUrl + "/" + mode + "/" + serviceidsExtension;

    console.log(url);

    var data = this.http.get(url)
      .pipe(
        map((array: any) => array = this.format_route_service_ids(array)),
        tap(_ => this.log('fetched route service ids')),
        catchError(this.handleError<any[]>('get', []))
      );

    return data;
  }

  private format_calendar(response: any, requested_date: string = ""): any {
    this.calendar = response;

    // If date is blank use today's date.
    let date: Date = new Date();

    var weekday = [];
    weekday[0] = "sunday";
    weekday[1] = "monday";
    weekday[2] = "tuesday";
    weekday[3] = "wednesday";
    weekday[4] = "thursday";
    weekday[5] = "friday";
    weekday[6] = "saturday";

    if (requested_date == "wqdwq") {
      date.setDate(27)
      date.setMonth(0o5)
      date.setFullYear(2019)
    }

    var service_date = date.getFullYear() + ("0" + (date.getMonth() + 1)).slice(-2) + ("0" + (date.getDate() + 1)).slice(-2);

    var service_ids: any[] = [];

    for (const dates of response) {
      if (dates.start_date <= service_date && dates.end_date >= service_date && dates[weekday[date.getDay()]] == 1) {
        service_ids.push(dates.service_id)
      }
    }

    this.calendar_service_id = service_ids;

    return service_ids;
  }

  private format_route_service_ids(response: any): any {
    var service_ids: any[] = this.route_service_ids;

    for (const dates of response) {
      service_ids.push(dates)
    }

    this.route_service_ids = service_ids;

    return service_ids;
  }

  private format_valid_service_ids(response: any): any {
    var service_ids: any[] = this.route_service_ids;

    for (const dates of response) {
      service_ids.push(dates)
    }

    this.route_service_ids = service_ids;

    return service_ids;
  }

  private format_timetables(response: any): any {

    var stops: any[] = []; 

    for (let country of Object.keys(response)) {
      var capital = response[country];
      stops[country] = capital;
    }

    console.log(stops);

    return stops;
  }

  private format_calendar_dates(response: any, requested_date: string = ""): any {

    this.calendar_dates = response;

    // If date is blank use today's date.
    let date: Date = new Date();

    if (requested_date == "wqdwq") {
      date.setDate(27)
      date.setMonth(0o5)
      date.setFullYear(2019)
    }

    var service_date = date.getFullYear() + ("0" + (date.getMonth() + 1)).slice(-2) + ("0" + (date.getDate() + 1)).slice(-2);

    var service_ids: any[] = [];

    for (const dates of response) {
      if (dates.start_date == service_date) {
        service_ids.push(dates.service_id)
      }
    }

    if (service_ids.length > 0) {
      this.special_schedule = true;
    }

    this.calendar_date_service_id = service_ids;

    return service_ids;
  }

  public get_service_ids(mode: string): Observable<any[]> {

    var url = calendarUrl + "/" + "/" + calendarExtension;

    var data = this.http.get(url)
      .pipe(
        map((array: any) => array = this.format_calendar(array, mode)),
        tap(_ => this.log('fetched stop times')),
        catchError(this.handleError<any[]>('get', []))
      );

    return data;
  }


  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a RouteService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`RouteService: ${message}`);
  }
}
